import { getAllInsurancesApi, createInsurancesApi, getInsurancesByIdApi, updateInsurancesApi,deleteInsurancesImageApi, deleteInsurancesApi } from "../../helpers/backend_helper";
import {
    getInsuranceList,
    insuranceByIdData,
    errorMessages,
    loadingData
} from "./reducer"

export const getAllInsurances = (
    currentPage,
    pageSize,
    searchText
) => async (dispatch) => {
    try {
        loadingData({ type: "read", value: true });
        const response = await getAllInsurancesApi(currentPage, pageSize, searchText);
        const data = await response;
        dispatch(getInsuranceList(data));
        return true;
    } catch (error) {
        const errorMessage = error.response.data.errors;
        dispatch(errorMessages(errorMessage));
        return false;
    } finally {
        dispatch(loadingData({ type: "read", value: false }));
    }
}


export const getInsuranceById = (id) => async (dispatch) => {
    try {
        dispatch(loadingData({ type: "getById", value: true }));
        let response;
        response = getInsurancesByIdApi(id);
        const data = await response;
        dispatch(insuranceByIdData(data));
    } catch (error) {
        const errorMessage = error.response.data.errors;
        dispatch(errorMessages(errorMessage));
    } finally {
        dispatch(loadingData({ type: "getById", value: false }));
    }
}


export const createInsurance = (data) => async (dispatch) => {
    try {
        dispatch(loadingData({ type: "create", value: true }));
        const response = await createInsurancesApi(data);
        return { success: true, message: "Insurance Successfully Created" };
    } catch (error) {
        const errorMessage = error.response.data.errors;
        dispatch(errorMessages(errorMessage));
        return {
            success: false,
            message: errorMessage || "Failed to create insurance",
        };
    } finally {
        dispatch(loadingData({ type: "create", value: false }));
    }
}


export const updateInsurance = (id, data) => async (dispatch) => {
    try {
        dispatch(loadingData({ type: "update", value: true }));
        let response;
        response = await updateInsurancesApi(id, data);
        return { success: true, message: "Insurance Successfully Updated" };
    } catch (error) {
        const errorMessage = error.response.data.errors;
        dispatch(errorMessages(errorMessage));
        return { success: false, message: errorMessage }
    } finally {
        dispatch(loadingData({ type: "update", value: false }));
    }
}


export const deleteInsurance = (id) => async (dispatch) => {
    try {
        dispatch(loadingData({ type: "delete", value: true }));
        let response;
        response = await deleteInsurancesApi(id);
        return { success: true, message: "Insurance Successfully Deleted" };
    } catch (error) {
        const errorMessage = error.response.data.errors;
        dispatch(errorMessages(errorMessage));
        return { success: false, message: errorMessage }
    } finally {
        dispatch(loadingData({ type: "delete", value: false }));
    }
}

export const deleteInsuranceImage = (id) => async (dispatch) => {
    try {
        dispatch(loadingData({ type: "deleteImage", value: true }));
        let response;
        response = await deleteInsurancesImageApi(id);
        return { success: true, message: "Insurance Successfully Deleted" };
    } catch (error) {
        const errorMessage = error.response.data.errors;
        dispatch(errorMessages(errorMessage));
        return { success: false, message: errorMessage }
    } finally {
        dispatch(loadingData({ type: "deleteImage", value: false }));
    }
}